export default "__VITE_ASSET__BbxaqIQ4__"